<template>
  <el-form ref="form" :model="curInput" :rules="rules" label-width="100px">
    <el-form-item label="日期类型" prop="type">
      <el-select v-model="curInput.date.type" placeholder="请选择日期类型" class="h-40 w-200">
        <el-option v-for="item in dateType" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="是否选择范围" prop="range_status">
      <el-radio-group v-model="curInput.date.range_status">
        <el-radio :label="1" :disabled="disabled">是</el-radio>
        <el-radio :label="0" :disabled="disabled">否</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <el-form-item label="可选最小值" prop="date_min">
      <el-radio-group v-model="curInput.date.date_min.type">
        <el-radio :label="item.id" v-for="item in limitType">{{ item.name }}</el-radio>
      </el-radio-group>
      <div>
        <el-input v-model.trim="curInput.date.date_min.var_limit" class="h-40 w-200" placeholder="请填写变量公式" v-if="curInput.date.date_min.type == DATE_LIMIT_VAR"></el-input>
      </div>
      <div>
        <el-date-picker v-model="curInput.date.date_min.fixed_value" :type="curDateType" :format="format" placeholder="选择可选最小值" v-if="curInput.date.date_min.type == DATE_LIMIT_FIXED && pickerShow"></el-date-picker>
      </div>
    </el-form-item>
    <el-form-item label="可选最大值" prop="date_max">
      <el-radio-group v-model="curInput.date.date_max.type">
        <el-radio :label="item.id" v-for="item in limitType">{{ item.name }}</el-radio>
      </el-radio-group>
      <div>
        <el-input v-model.trim="curInput.date.date_max.var_limit" class="h-40 w-200" placeholder="请填写变量公式" v-if="curInput.date.date_max.type == DATE_LIMIT_VAR"></el-input>
      </div>
      <div>
        <el-date-picker v-model="curInput.date.date_max.fixed_value" :type="curDateType" :format="format" placeholder="选择可选最大值" v-if="curInput.date.date_max.type == DATE_LIMIT_FIXED && pickerShow"></el-date-picker>
      </div>
    </el-form-item>
    <el-form-item label="是否设置默认值" prop="is_null">
      <el-radio-group v-model="curInput.date.date_default.is_null">
        <el-radio :label="0">是</el-radio>
        <el-radio :label="1">否</el-radio>
      </el-radio-group>
      <div v-if="curInput.date.date_default.is_null == 0 && curInput.date.range_status == 0">
        <el-input v-model.trim="curInput.date.date_default.single" placeholder="请填写公式" class="h-40 w-200"></el-input>
      </div>
      <div v-if="curInput.date.date_default.is_null == 0 && curInput.date.range_status == 1">
        <el-input v-model.trim="curInput.date.date_default.range_start" placeholder="请填写起始日期公式" class="h-40 w-200"></el-input>
        <el-input v-model.trim="curInput.date.date_default.range_end" placeholder="请填写结束日期公式" class="h-40 w-200"></el-input>
      </div>
    </el-form-item>
    <el-form-item label="快捷选项">
      <div v-for="(item, index) in curInput.date.quick_config">
        <el-input v-model.trim="item.name" placeholder="选项名称" class="h-40 w-100"></el-input>
        <el-input v-model.trim="item.single" placeholder="选项值（变量公式）" class="h-40 w-160" v-if="curInput.date.range_status == 0"></el-input>
        <el-input v-model.trim="item.start" placeholder="起始日期选项值" class="h-40 w-160" v-if="curInput.date.range_status == 1"></el-input>
        <el-input v-model.trim="item.end" placeholder="结束日期选项值" class="h-40 w-160" v-if="curInput.date.range_status == 1"></el-input>
        <el-button size="small" type="danger" @click="deleteConfig(index)">删除</el-button>
      </div>
      <div>
        <el-button type="primary" @click="addConfig()">添加</el-button>
      </div>
    </el-form-item>
    <div class="form-tips">变量公式说明：Y代表年，M代表月，D代表天，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，Y+1 & M+1代表一年又一个月后</div>
  </el-form>
</template>

<script>
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
        curDateType: 'date',
        format: '',
        disabled: false,
        pickerShow: true, // 用于控制时间控件类型转换
        dateType: [
          { id: 10, name: '日' },
          // { id: 20, name: '周' },
          { id: 30, name: '月' },
          { id: 40, name: '年' }
        ],
        limitType: [
          { id: 10, name: '不限' },
          { id: 20, name: '变量公式' },
          { id: 30, name: '固定值' }
        ],
        inputChange: false
      }
    },
    mixins: [modelConfig],
    methods: {
      addConfig() { // 添加配置
        this.curInput.date.quick_config.push({ single: '', name: '', start: '', end: '' })
      },
      deleteConfig(index) { // 删除配置
        this.curInput.date.quick_config.splice(index, 1)
      },
      resetInput(func) {
        this.pickerShow = false
        func()
        setTimeout(() => {
          this.pickerShow = true
        }, 1)
      },
      resetDefault() {
        this.curInput.date.date_default.single = ''
        this.curInput.date.date_default.range_start = ''
        this.curInput.date.date_default.range_end = ''
      },
      setInputChange(value) {
        this.inputChange = value
      }
    },
    watch: {
      'curInput'() {
        this.setInputChange(true)
      },
      'curInput.date.date_default.is_null'() {
        if (this.inputChange) {
          return
        }
        this.resetDefault()
      },
      'curInput.date.range_status'() {
        if (this.inputChange) {
          return
        }
        this.resetDefault()
      },
      'curInput.date.type'() {
        this.resetInput(() => {
          this.format = ''
          this.disabled = true
          if (this.curInput.date.type == this.DATE_DAY) {
            this.curDateType = 'date'
            this.disabled = false
          } else if (this.curInput.date.type == this.DATE_WEEK) {
            this.curDateType = 'date'
          } else if (this.curInput.date.type == this.DATE_MONTH) {
            this.curDateType = 'month'
          } else if (this.curInput.date.type == this.DATE_YEAR) {
            this.curDateType = 'year'
          }
        })
        if (this.inputChange) {
          return
        }
        this.curInput.date.range_status = 0
        this.curInput.date.date_min.fixed_value = ''
        this.curInput.date.date_max.fixed_value = ''
      },
      'inputChange'() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// dateConfig.vue?63ecdb2c